// recovery-gift-publico-01 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    ", nível %{order}.": ", nivel %{order}.",
    "Público definido pela campanha": "Público definido por la campaña",
    "Só aparece para quem está inscrito na campanha e está no nível deste brinde; quem já conquistou sai da lista. A segmentação não é por etiqueta nem por grupo, então não há lista para mostrar aqui.": "Solo aparece para quien está inscrito en la campaña y está en el nivel de este premio; quien ya lo consiguió sale de la lista. La segmentación no es por etiqueta ni por grupo, así que no hay lista para mostrar aquí.",
};

export default catalogo;
